import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseComponent} from '../../core/base.component';
import { ActivatedRoute, RouterLink } from '@angular/router';
import {HeaderService} from '../../core/services/header.service';
import {Title} from '@angular/platform-browser';
import {AccountService} from '../account.service';
import {AccountRoleModel} from '../../api/models/account-role-model';
import {AuthService} from '../../core/security/auth.service';
import {ModuleDefinition, RolesDefinition} from '../../core/security/role-definition';
import {RolesEnum} from '../../core/security/roles.enum';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { NgIf, NgFor } from '@angular/common';
import { MatAnchor } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { DateTimePipe } from '../../core/pipes/date-time.pipe';

@Component({
    selector: 'app-role',
    templateUrl: './role.component.html',
    styleUrls: ['./role.component.scss'],
    standalone: true,
    imports: [
        MatCard,
        MatCardTitle,
        MatCardContent,
        NgIf,
        MatCardActions,
        MatAnchor,
        MatTooltip,
        RouterLink,
        NgFor,
        DateTimePipe,
    ],
})
export class RoleComponent extends BaseComponent implements OnInit, OnDestroy {

  public displayModel: AccountRoleModel = {id: null, items: []};
  public editUrl: string;
  private paramsSubscription;
  private id: string;
  public modules: ModuleDefinition[];

  constructor(route: ActivatedRoute, headerService: HeaderService, titleService: Title, authService: AuthService,
              private accountService: AccountService) {
    super(route, headerService, titleService, authService);

    this.paramsSubscription = this.route.params.subscribe(params => {
      this.id = params['id'];
      console.log(this.id);
    });

    this.editUrl = './edit';
    this.headerService.showBackButton(true);

    this.editRoles = [RolesEnum.AccountRoles_Edit, RolesEnum.AccountRoles_Delete];
    this.deleteRoles = [RolesEnum.AccountRoles_Delete];
  }

  async ngOnInit() {
    super.ngOnInit();
    this.displayModel = await this.accountService.getRoleById(this.id);

    const currentUser = this.authService.currentUser.getValue();
    this.modules = RolesDefinition.userModules(currentUser.modules, this.displayModel.items);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.paramsSubscription?.unsubscribe();
    this.headerService.showBackButton(false);
  }

}
